/* Manifest List, Vue Component */
<template>
  <v-card id="manifest-list">

    <v-card-title>Manifest Settings</v-card-title>
    <hr style="margin-bottom:20px" />
    <v-card-text class="manifest-settings-grid">
      <div class="manifest-settings-section">
        <h3>Jersey Small</h3>
        <v-text-field v-model.number="request.JerseySmall" label="Expected delivery" type="number" min="0" outlined
          dense hide-details class="mb-4" style="max-width: 220px;"></v-text-field>
        <v-checkbox v-model="request.JerseySmallManifestToTTLMD" label="Manifest to TTLMD" hide-details
          class="mt-0"></v-checkbox>
        <v-text-field v-model="request.JerseySmallCarrierToManifestTo" label="Carrier to Manifest to" outlined dense
          hide-details class="my-4"></v-text-field>
        <v-text-field v-model="request.JerseySmallShipperToManifestTo" label="Shipper to Manifest to" outlined dense
          hide-details class="mb-4"></v-text-field>
        <v-text-field v-model="request.JerseySmallCustomsCsvEmail" label="Customs CSV Email" outlined dense
          hide-details class="mb-4"></v-text-field>
        <v-text-field v-model="request.JerseySmallEasytransCsvEmail" label="Easytrans CSV Email" outlined dense
          hide-details></v-text-field>

      </div>

      <div class="manifest-settings-section">
        <h3>Jersey Two Person</h3>
        <v-text-field v-model.number="request.JerseyLarge" label="Expected delivery" type="number" min="0" outlined
          dense hide-details class="mb-4" style="max-width: 220px;"></v-text-field>
        <v-checkbox v-model="request.JerseyTwoPersonManifestToTTLMD" label="Manifest to TTLMD" hide-details
          class="mt-0"></v-checkbox>
        <v-text-field v-model="request.JerseyTwoPersonCarrierToManifestTo" label="Carrier to Manifest to" outlined dense
          hide-details class="my-4"></v-text-field>
        <v-text-field v-model="request.JerseyTwoPersonShipperToManifestTo" label="Shipper to Manifest to" outlined dense
          hide-details class="mb-4"></v-text-field>
        <v-text-field v-model="request.JerseyTwoPersonCustomsCsvEmail" label="Customs CSV Email" outlined dense
          hide-details class="mb-4"></v-text-field>
        <v-text-field v-model="request.JerseyTwoPersonEasytransCsvEmail" label="Easytrans CSV Email" outlined dense
          hide-details></v-text-field>

      </div>

      <div class="manifest-settings-section">
        <h3>Guernsey Small</h3>
        <v-text-field v-model.number="request.GuernseySmall" label="Expected delivery" type="number" min="0" outlined
          dense hide-details class="mb-4" style="max-width: 220px;"></v-text-field>
        <v-checkbox v-model="request.GuernseySmallManifestToTTLMD" label="Manifest to TTLMD" hide-details
          class="mt-0"></v-checkbox>
        <v-text-field v-model="request.GuernseySmallCarrierToManifestTo" label="Carrier to Manifest to" outlined dense
          hide-details class="my-4"></v-text-field>
        <v-text-field v-model="request.GuernseySmallShipperToManifestTo" label="Shipper to Manifest to" outlined dense
          hide-details class="mb-4"></v-text-field>
        <v-text-field v-model="request.GuernseySmallCustomsCsvEmail" label="Customs CSV Email" outlined dense
          hide-details class="mb-4"></v-text-field>
        <v-text-field v-model="request.GuernseySmallEasytransCsvEmail" label="Easytrans CSV Email" outlined dense
          hide-details></v-text-field>

      </div>

      <div class="manifest-settings-section">
        <h3>Guernsey Two Person</h3>
        <v-text-field v-model.number="request.GuernseyLarge" label="Expected delivery" type="number" min="0" outlined
          dense hide-details class="mb-4" style="max-width: 220px;"></v-text-field>
        <v-checkbox v-model="request.GuernseyTwoPersonManifestToTTLMD" label="Manifest to TTLMD" hide-details
          class="mt-0"></v-checkbox>
        <v-text-field v-model="request.GuernseyTwoPersonCarrierToManifestTo" label="Carrier to Manifest to" outlined
          dense hide-details class="my-4"></v-text-field>
        <v-text-field v-model="request.GuernseyTwoPersonShipperToManifestTo" label="Shipper to Manifest to" outlined
          dense hide-details class="mb-4"></v-text-field>
        <v-text-field v-model="request.GuernseyTwoPersonCustomsCsvEmail" label="Customs CSV Email" outlined dense
          hide-details class="mb-4"></v-text-field>
        <v-text-field v-model="request.GuernseyTwoPersonEasytransCsvEmail" label="Easytrans CSV Email" outlined dense
          hide-details></v-text-field>

      </div>
    </v-card-text>
    <hr style="margin:20px 0" />

    <v-card-text class="d-flex align-center flex-wrap pb-0">
      <div class="d-flex align-center pb-5">
        <v-btn color="primary" class="me-3" @click="updateSettings">
          <span>Update</span>
        </v-btn>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import store from '@/store'

import { mdiPlus } from '@mdi/js'

import { ref, watch, computed } from '@vue/composition-api'
import * as Validators from '@/datahelpers/validation'
import * as Display from '@/datahelpers/displayTypes'
import CountrySelect from '@/views/country/CountrySelect'

export default {
  components: {
    CountrySelect,
  },
  setup() {

    const loading = ref(false)

    // data for filter fields
    const filterItems = ref({
      Closed: [
        { text: 'Open', value: false },
        { text: 'Closed', value: true },
      ],
    })

    const request = ref({
      JerseyMon: false,
      JerseyTue: false,
      JerseyWed: false,
      JerseyThu: false,
      JerseyFri: false,
      JerseySmall: 3,
      JerseyLarge: 5,
      JerseySmallCarrierToManifestTo: '',
      JerseySmallShipperToManifestTo: '',
      JerseySmallCustomsCsvEmail: '',
      JerseySmallEasytransCsvEmail: '',
      JerseyTwoPersonCarrierToManifestTo: '',
      JerseyTwoPersonShipperToManifestTo: '',
      JerseyTwoPersonCustomsCsvEmail: '',
      JerseyTwoPersonEasytransCsvEmail: '',
      JerseySmallManifestToTTLMD: false,
      JerseyTwoPersonManifestToTTLMD: false,
      GuernseyMon: false,
      GuernseyTue: false,
      GuernseyWed: false,
      GuernseyThu: false,
      GuernseyFri: false,
      GuernseySmall: 3,
      GuernseyLarge: 5,
      GuernseySmallCarrierToManifestTo: '',
      GuernseySmallShipperToManifestTo: '',
      GuernseySmallCustomsCsvEmail: '',
      GuernseySmallEasytransCsvEmail: '',
      GuernseyTwoPersonCarrierToManifestTo: '',
      GuernseyTwoPersonShipperToManifestTo: '',
      GuernseyTwoPersonCustomsCsvEmail: '',
      GuernseyTwoPersonEasytransCsvEmail: '',
      GuernseySmallManifestToTTLMD: false,
      GuernseyTwoPersonManifestToTTLMD: false,
    })

    const updateSettings = () => {
      loading.value = true
      store
        .dispatch('app/updateManifestSettings', request.value)
        .then(response => {
          loading.value = false
        })
        .catch(error => {
          console.log(error)
        })
    }
    // method for data loading via vuex
    const fetchData = () => {
      loading.value = true
      store
        .dispatch('app/fetchManifestSettings')
        .then(response => {
          loading.value = false
          request.value = response.data
        })
        .catch(error => {
          console.log(error)
        })
    }
    fetchData()
    return {
      loading,
      request,
      updateSettings,
      Validators,
      Display,
      icons: {
        mdiPlus,
      },
    }
  },
}
</script>

<style lang="scss" scoped>
.manifest-settings-grid {
  display: grid;
  gap: 20px;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
}

.manifest-settings-section {
  border: 1px solid rgba(94, 86, 105, 0.14);
  border-radius: 8px;
  padding: 20px;
}

.manifest-settings-section h3 {
  margin-bottom: 16px;
}
</style>
